// モーダル関連の機能を分離
export function openDownloadModal(whitepaperId, whitepaperTitle) {
  // ページ内フォームへスクロール
  if (window.scrollToDownloadForm) {
    window.scrollToDownloadForm();
  } else {
    // フォールバック: URLにハッシュを追加してリロード
    window.location.href = `/whitepaper/${whitepaperId}#download`;
  }
  return;
  
  /* 旧実装（一時的に無効化）
  const modal = document.getElementById('downloadModal');
  const form = document.getElementById('downloadForm');
  const whitepaperIdInput = document.getElementById('whitepaperId');
  
  whitepaperIdInput.value = whitepaperId;
  modal.style.display = 'block';
  
  // フォーム送信イベント
  form.onsubmit = async (e) => {
    e.preventDefault();
    await handleFormSubmit(form, whitepaperTitle);
  };
}

export function closeDownloadModal() {
  const modal = document.getElementById('downloadModal');
  modal.style.display = 'none';
}

async function handleFormSubmit(form, whitepaperTitle) {
  const formData = new FormData(form);
  const data = Object.fromEntries(formData);
  
  try {
    // Firestoreにリード情報を保存（実装予定）
    const leadData = {
      ...data,
      whitepaperTitle,
      downloadedAt: new Date(),
      source: 'whitepaper-site'
    };
    
    // 成功メッセージを表示
    alert('ダウンロードリンクをメールでお送りしました。');
    closeDownloadModal();
    form.reset();
    
  } catch (error) {
    console.error('Error:', error);
    alert('エラーが発生しました。もう一度お試しください。');
  }
  */
}

export function closeDownloadModal() {
  const modal = document.getElementById('downloadModal');
  if (modal) {
    modal.style.display = 'none';
  }
}

// グローバルに公開（onclick用）
window.openDownloadModal = openDownloadModal;
window.closeDownloadModal = closeDownloadModal;